import themeServiceImpl from '../theme-service';
import type { ThemeService } from './contracts';

export type { ContrastingColors, ThemeValues, ThemeService } from './contracts';
export { getBrandLogo, getDefaultThemeForHost, isAlphaFlashHost } from '../host-theme-config';
export const themeService: ThemeService = themeServiceImpl;
